import { render, staticRenderFns } from "./ApelidoInput.vue?vue&type=template&id=0aab5db2&scoped=true&"
import script from "./ApelidoInput.vue?vue&type=script&lang=js&"
export * from "./ApelidoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aab5db2",
  null
  
)

export default component.exports